<header
  class="header-container"
  *ngIf="this.getNome() === 'null' ? false : true">
  <div class="logo-container">
    <img
      class="logo"
      [src]="brand.logoHeader"
      (click)="navigateHome()" />
  </div>
  <div class="user">
    <div class="user-image">
      <img src="assets/icon-person.png" />
    </div>
    <div class="user-info">
      <span class="user-name">{{ getNome() }}</span>
    </div>
    <!-- <span class="logout" (click)="infoUserAccept()">
      <img src="assets/termoUso.svg" />
      <span>Termo de uso e consentimento</span>
    </span> -->
    <span class="logout" (click)="logout()">
      <img src="assets/logout-v2.svg" />
      <span>Sair</span>
    </span>
  </div>
</header>
